module.exports = __webpack_public_path__ + "static/media/timesheet_share.41ceedbf.svg";